import { Theme } from "../constants";

export default {
    h1Body: { 
        fontWeight: '700',
        fontSize: '24px',
        lineHeight: '29px',
        color: Theme.TEXT_PRIMARY_BLACK
    },
    
    h2Body: {         
        fontWeight: '700',
        fontSize: '20px',
        lineHeight: '29px',
        color: Theme.TEXT_PRIMARY_BLACK,
    },

    h3Body: {         
        fontWeight: '700',
        fontSize: '16px',
        lineHeight: '29px',
        color: Theme.TEXT_PRIMARY_BLACK,
    },
}